import { useContext, useEffect } from 'react'
import { HideLoder, ShowLoder, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY } from '../JS/Common';
import { ApiGetCall } from '../JS/Connector';
import { useState } from 'react';
import Tab from './Tab';
import Popup from './Popup';
import { faDollarSign, faStamp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserContext } from '../App';
import { hasRoleAccess, RoleEnum } from '../JS/RoleType';
import useConfig from "../Hooks/useConfig";
import { Accordion } from 'react-bootstrap';

export default function UserDetailsPopup(props) {
    const { UserData } = useContext(UserContext);
    const { manager, show_device_complete_club, show_grade_field, invoie_number_lable_user_wise,
        invoie_status_lable_user_wise, invoice_amount_lable_user_wise, dcc_module_text, sm_dcc_text
    } = useConfig();

    const [loading, setLoading] = useState(false);
    const [userdata, setuserdata] = useState([]);
    const [planData, setPlanData] = useState("");
    const [policyflag, setpolicyflag] = useState("");
    const [userHistory, setUserHistory] = useState([]);
    const [claimLog, setClaimLog] = useState([]);
    const [currentAllocation, setcurrentAllocation] = useState([]);
    const [pastAllocation, setpastAllocation] = useState([]);
    const [CurrentTickets, setCurrentTickets] = useState([]);
    const [PastTickets, setPastTickets] = useState([]);
    const [isstudent, setisstudent] = useState(0);
    const [Tabactive, setTabActive] = useState({
        UserdetailsTab: "active",
        UserHistoryTab: "",
        PlanHistoryTab: '',
        UserTicketsTab: ''
    });
    const [activeKey, setActiveKey] = useState("0");
    const [noteVisibility, setNoteVisibility] = useState({});
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const ExcludeVar = hasRoleAccess(effectiveRole, RoleEnum.COMN_EXCLUDE_VAR);

    useEffect(() => {
        setLoading(true)
        ApiGetCall(`/students/by-id?userId=${props.userid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setisstudent(responseRs?.msg?.is_student)
                setuserdata(responseRs.msg || []);
                setpolicyflag(responseRs.student_agree_policy);
                setpastAllocation(responseRs.past_allocation || [])
                setcurrentAllocation(responseRs.current_allocation || [])
                setUserHistory(responseRs.device_allocation_logs || []);
                setPlanData(responseRs.parental_coverage_details || "");
                setClaimLog(responseRs.parental_coverage_claim_details || []);
                const combinedTickets = responseRs.current_allocation.flatMap(device =>
                    device.ticket_details.map(ticket => ({
                        ...ticket,
                        serial_number: device.serial_number,
                    }))
                );
                setCurrentTickets(combinedTickets)
                const combinedpastTickets = responseRs.past_allocation.flatMap(device =>
                    device.ticket_details.map(ticket => ({
                        ...ticket,
                        serial_number: device.serial_number,
                    }))
                );
                setPastTickets(combinedpastTickets)
            }
        });
    }, []);
    function handleArrowClick(ticketId) {
        setNoteVisibility(prevID => (prevID == ticketId ? null : ticketId));
    }
    function handleTabClick(tabType) {
        if (tabType == "userdetails") {
            setTabActive({ ...Tabactive, UserdetailsTab: "active", UserHistoryTab: "", PlanHistoryTab: '', UserTicketsTab: '' });
        } else if (tabType == "userhistory") {
            setTabActive({ ...Tabactive, UserdetailsTab: "", UserHistoryTab: "active", PlanHistoryTab: '', UserTicketsTab: '' });
        } else if (tabType == "parental") {
            setTabActive({ ...Tabactive, UserdetailsTab: "", UserHistoryTab: "", PlanHistoryTab: 'active', UserTicketsTab: '' });
        } else if (tabType == "usertickets") {
            setTabActive({ ...Tabactive, UserdetailsTab: "", UserHistoryTab: "", PlanHistoryTab: '', UserTicketsTab: 'active' });
        }
    }
    const modalbody = (
        <>
            <ul className="nav nav-tabs">
                <Tab isActive={Tabactive.UserdetailsTab == 'active'}
                    label="User Details" onClick={() => handleTabClick('userdetails')} col={'col-md-2'} />
                <Tab isActive={Tabactive.UserHistoryTab == 'active'}
                    label="Device History" onClick={() => handleTabClick('userhistory')} col={'col-md-3'} />
                {ExcludeVar && show_device_complete_club ?
                    <Tab isActive={Tabactive.PlanHistoryTab == 'active'}
                        label={`${dcc_module_text} History`} onClick={() => handleTabClick('parental')} col={'col-md-4'} />
                    : null
                }
                <Tab isActive={Tabactive.UserTicketsTab == 'active'}
                    label="User Tickets" onClick={() => handleTabClick('usertickets')} col={'col-md-2'} />
            </ul>

            {Tabactive.UserdetailsTab == 'active' && (
                <div >
                    <div className="row my-3" style={{ fontSize: "13px" }}>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">First Name : </div>
                            <div className="col fw-600"> {userdata?.device_user_first_name}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">Middle Name : </div>
                            <div className="col fw-600">{userdata?.device_user_middle_name || '-'}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">Last Name : </div>
                            <div className="col fw-600">{userdata?.device_user_last_name}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">User ID : </div>
                            <div className="col fw-600">{userdata?.student_num}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">User Email : </div>
                            <div className="col fw-600">{userdata?.student_email || '-'}</div>
                        </div>
                        {show_grade_field &&
                            <>
                                <div className="col-lg-6 row py-1">
                                    <div className="col">Is the user a student?  : </div>
                                    <div className="col fw-600">{isstudent == 1 ? 'Yes' : 'No'}</div>
                                </div>
                                <div className="col-lg-6 row py-1">
                                    <div className="col">Grade  : </div>
                                    <div className="col fw-600">{userdata?.grade || '-'}</div>
                                </div>
                            </>
                        }
                        <div className="col-lg-6 row py-1">
                            <div className="col">Department  : </div>
                            <div className="col fw-600">{userdata?.department || '-'}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col">{manager} Email : </div>
                            <div className="col fw-600">{userdata?.parent_guardian_email || '-'}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col ">{manager} Name : </div>
                            <div className="col fw-600">{userdata?.parent_guardian_name || '-'}</div>
                        </div>
                        <div className="col-lg-6 row py-1">
                            <div className="col">{manager} Contact : </div>
                            <div className="col fw-600">{userdata?.parent_phone_number || '-'}</div>
                        </div>
                        {ExcludeVar && show_device_complete_club ?
                            <>
                                <div className="col-lg-6 row py-1">
                                    <div className="col">{dcc_module_text} : </div>
                                    <div className="col fw-600">{userdata?.parental_coverage == 1 ? 'Yes' : 'No'}</div>
                                </div>

                                <div className="col-lg-6 row py-1">
                                    <div className="col">Fair Use Acknowledgment : </div>
                                    <div className="col fw-600">{policyflag == 1 ? 'Yes' : policyflag == 0 ? 'No' : '-'}</div>
                                </div>
                            </>
                            : null
                        }
                    </div>
                    <hr />
                    <div className='row'>
                        <h5 className='fw-600'>Current Allocated Devices</h5>
                        {currentAllocation?.length != 0 ?
                            currentAllocation?.map((item, i) => {
                                return (
                                    <div className="row font-14" key={i}>
                                        <div className="col-md-12">
                                            <div className="row" style={{ fontSize: "13px" }}>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6 " > Serial #:  </div>
                                                        <div className="col-md-6 text-md-start text-center wordwrap"> <b>{item.serial_number}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device Model: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_model ? item.device_model : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">  Device Manufacturer: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_manufacturer ? item.device_manufacturer : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device MPN:  </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_mpn ? item.device_mpn : <>-</>}</b></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">   Asset Tag: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.asset_tag ? item.asset_tag : <>-</>}</b>  </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">  Repair Cap:   </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.repair_cap ? `$${item.repair_cap}` : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device Os: </div>
                                                        <div className="col-md-6 text-md-start text-center">  <b>{item.device_os ? item.device_os : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Allocated Date: </div>
                                                        <div className="col-md-6 text-md-start text-center">  <b>{item.allocate_date ? formatDateToMMDDYYYY(item.allocate_date) : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-3 col-8"> Notes: </div>
                                                        <div className="col-md-9 col-4 text-md-start text-center">  <b>{item.notes ? item.notes : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <img src="/images/HorizontalLine.svg" className="img-fluid w-100 pt-2" />
                                    </div>
                                )
                            })
                            :
                            <div className="col-12 text-center p-2">  No Record Found  </div>
                        }
                        <h5 className='fw-600 pt-3'>Past Allocated Devices</h5>
                        {pastAllocation?.length != 0 ?
                            pastAllocation?.map((item, i) => {
                                return (
                                    <div className="row font-14" key={i}>
                                        <div className="col-md-12">
                                            <div className="row" style={{ fontSize: "13px" }}>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6 " > Serial #:  </div>
                                                        <div className="col-md-6 text-md-start text-center wordwrap"> <b>{item.serial_number}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device Model: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_model ? item.device_model : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">  Device Manufacturer: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_manufacturer ? item.device_manufacturer : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device MPN:  </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.device_mpn ? item.device_mpn : <>-</>}</b></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center  pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">   Asset Tag: </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.asset_tag ? item.asset_tag : <>-</>}</b>  </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">  Repair Cap:   </div>
                                                        <div className="col-md-6 text-md-start text-center"> <b>{item.repair_cap ? `$${item.repair_cap}` : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Device Os: </div>
                                                        <div className="col-md-6 text-md-start text-center">  <b>{item.device_os ? item.device_os : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Allocated Date: </div>
                                                        <div className="col-md-6 text-md-start text-center">  <b>{item.allocate_date ? formatDateToMMDDYYYY(item.allocate_date) : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6"> Vacant Date: </div>
                                                        <div className="col-md-6 text-md-start text-center">  <b>{item.vacant_date ? formatDateToMMDDYYYY(item.vacant_date) : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12  align-items-center pt-2">
                                                    <div className="row">
                                                        <div className="col-md-3 col-8"> Notes: </div>
                                                        <div className="col-md-9 col-4 text-md-start text-center">  <b>{item.notes ? item.notes : <>-</>}</b> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <img src="/images/HorizontalLine.svg" className="img-fluid w-100 pt-2" />
                                    </div>
                                )
                            })
                            :
                            <div className="col-12 text-center p-2">  No Record Found  </div>
                        }
                    </div>
                </div>
            )}

            {Tabactive.UserHistoryTab == 'active' && (
                <div>
                    <div className="col-12 greyBox p-3 my-3">
                        <table className="table">
                            <thead className="GridHeader">
                                <tr>
                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                        Serial No. #
                                    </th>
                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                        Allocated Date
                                    </th>
                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                        Loaner Device Allocation Date
                                    </th>
                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                        Vacant Date
                                    </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userHistory?.length != 0 ? (
                                    userHistory?.map((item, i) => {
                                        const isNoteVisible = item.id === noteVisibility;
                                        var returData = (
                                            <tr key={i} className="OddEvenClass tableBorderHide">
                                                <td className="py-12 text-start">
                                                    {item.inventory.serial_number || '-'}
                                                </td>
                                                <td className="py-12 text-start">
                                                    {item.allocated_date ? formatDateToMMDDYYYY(item.allocated_date) : <>-</>}
                                                </td>
                                                <td className="py-12 text-start">
                                                    {item.loner_allocation_date ? formatDateToMMDDYYYY(item.loner_allocation_date) : <>-</>}
                                                </td>
                                                <td className="py-12 text-start">
                                                    {item.vacant_date ? formatDateToMMDDYYYY(item.vacant_date) : <>-</>}
                                                </td>
                                                <td>
                                                    <img src="/images/DownRoundArrow.svg" title="Show More Details" className={`cursor-pointer img-fluid ${isNoteVisible ? "d-none" : ""}`} ticketid={item.id} onClick={() => handleArrowClick(item.id)} />
                                                    <img src="/images/UpRoundArrow.svg" title="Hide More Details" className={`img-fluid cursor-pointer ${isNoteVisible ? "" : "d-none"}`} ticketid={item.id} onClick={() => handleArrowClick(item.id)} />
                                                </td>
                                            </tr>
                                        )
                                        if (isNoteVisible) {
                                            returData = (
                                                <>
                                                    {returData}
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            {item?.inventory?.ticket?.length != 0 ?
                                                                <>
                                                                    {item?.inventory?.ticket?.map((itemData, i) => {
                                                                        var returData = <div className="col-12 py-1" key={i}>
                                                                            Ticket number <b>{itemData.ticket_num}</b> was created on {itemData.created_at ? formatDateToUsaMMDDYYYY(itemData.created_at) : '-'}.
                                                                        </div>
                                                                        return returData;
                                                                    })}
                                                                </>
                                                                :
                                                                <div className="col-12 text-center">
                                                                    <label>No Record Found</label>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>

                                                </>
                                            );
                                        }
                                        return returData;
                                    })
                                ) :
                                    <tr>
                                        <td colspan={5} className="text-center">
                                            No Record Found
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            )}


            {Tabactive.PlanHistoryTab == 'active' && (
                <>
                    {planData?.length > 0 ?
                        <>
                            {planData?.map((item, idx) => (
                                <Accordion defaultActiveKey="0" activeKey={activeKey} onSelect={setActiveKey} className='my-3 mx-0'>
                                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                                        <Accordion.Header>{item?.plan_name || '-'}</Accordion.Header>
                                        <Accordion.Body>
                                            {item.enrollment_status == 2 &&
                                                <div className='blueText fw-600 fs-6 mt-3'>This {sm_dcc_text} is expired.</div>
                                            }
                                            {item.refund_status == 1 &&
                                                <div className='blueText fw-600 fs-6 mt-3'>This user is refunded.</div>
                                            }
                                            <div className="row my-3">
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600">Club Name : </div>
                                                    <div className="col"> {item?.plan_name || '-'}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600"> No of Claims : </div>
                                                    <div className="col wordwrap fw-600" style={{ color: 'var(--primary-color)' }}> {item?.claim_count || '-'}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600"> Club Price : </div>
                                                    <div className="col wordwrap"> ${item?.plan_price || 0}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600"> Paid Amount : </div>
                                                    <div className="col wordwrap"> ${item?.paid_amount || 0}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600">Sign Up Start Date: </div>
                                                    <div className="col"> {item?.start_date ? formatDateToMMDDYYYY(item?.start_date) : '-'}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600">Sign Up End Date : </div>
                                                    <div className="col"> {item?.end_date ? formatDateToMMDDYYYY(item?.end_date) : '-'}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600">{dcc_module_text} Start Date : </div>
                                                    <div className="col"> {item?.coverage_start_date ? formatDateToMMDDYYYY(item?.coverage_start_date) : '-'}</div>
                                                </div>
                                                <div className="col-lg-6 row py-1">
                                                    <div className="col fw-600">{dcc_module_text} End Date : </div>
                                                    <div className="col"> {item?.coverage_end_date ? formatDateToMMDDYYYY(item?.coverage_end_date) : '-'}</div>
                                                </div>

                                                <div className='col-12 pt-3'>
                                                    <div className="greyBox">
                                                        <table className="table">
                                                            <thead className="GridHeader">
                                                                <tr>
                                                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                                                        Ticket No. #
                                                                    </th>
                                                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                                                        Serial No. #
                                                                    </th>
                                                                    <th scope="col" className="cursor-pointer fw-600 text-start">
                                                                        Claim Date
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item?.parental_coverage_claim_details?.length > 0 ? (
                                                                    item?.parental_coverage_claim_details?.map((item, i) => {
                                                                        var returData = (
                                                                            <tr key={i} className="OddEvenClass tableBorderHide">
                                                                                <td className="py-12 text-start">
                                                                                    {item.ticket_num || '-'}
                                                                                </td>
                                                                                <td className="py-12 text-start">
                                                                                    {item.serial_num || '-'}
                                                                                </td>
                                                                                <td className="py-12 text-start">
                                                                                    {item.date ? formatDateToUsaMMDDYYYY(item.date) : <>-</>}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                        return returData;
                                                                    })
                                                                ) :
                                                                    <tr>
                                                                        <td colspan={5} className="text-center"> No Record Found </td>
                                                                    </tr>
                                                                }

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            ))}



                        </>
                        :
                        <div className='text-center pt-4'>No Record Found</div>
                    }
                </>
            )}

            {Tabactive.UserTicketsTab == 'active' && (
                <div>
                    <div className="row scrollbar-css-ticketform h-100 mt-3">
                        <h5 className='fw-600'>Current Allocated Devices Tickets</h5>
                        {CurrentTickets.length != 0 ?
                            CurrentTickets.map((item, i) => {
                                return <div className="col-md-12" key={i}>
                                    <div className="row" style={{ fontSize: "13px" }}>
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">Serial Number : </div>
                                            <div className="col fw-600">{item.serial_number}</div>
                                        </div>
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">{invoie_number_lable_user_wise} : </div>
                                            <div className="col fw-600">{item.parent_invoice_number || '-'}</div>
                                        </div >
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">Ticket Number : </div>
                                            <div className="col fw-600">{item.ticket_num || '-'}</div>
                                        </div>
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col " style={{ whiteSpace: "pre-line" }}>
                                                {`${invoie_status_lable_user_wise} : `}
                                            </div>
                                            <div className="col fw-600">{item.parent_invoice_status == 1 ?
                                                (
                                                    <FontAwesomeIcon icon={faStamp} title="Paid" className='' style={{ height: '14px', color: 'var(--paid_color)' }}
                                                    />) : (
                                                    <FontAwesomeIcon icon={faStamp} title="Not paid" className='' style={{ height: '14px', color: 'var(--unpaid_color)' }}
                                                    />)}</div>
                                        </div >
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">Created at : </div>
                                            <div className="col fw-600">{item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'}</div>
                                        </div>

                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">{invoice_amount_lable_user_wise} : </div>
                                            <div className="col fw-600">{item.parent_invoice_amount ? `$${item.parent_invoice_amount}` : <>-</>}</div>
                                        </div >
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">Ticket Status : </div>
                                            <div className="col fw-600">{item.status || '-'}</div>
                                        </div>
                                        <div className="col-lg-6 row py-1 pe-0">
                                            <div className="col ">Billable : </div>
                                            <div className="col fw-600">
                                                <FontAwesomeIcon
                                                    className={`${item.chargeability == 1 ? 'text-blue-billable' : 'text-gray-billable'}`}
                                                    icon={faDollarSign}
                                                    style={{ height: '13px' }}
                                                    title={item.chargeability == 1 ? 'Billable' : 'Non-billable'}
                                                />
                                            </div>
                                        </div>
                                        <hr />
                                    </div >
                                </div >
                            })
                            :
                            <div className="col-12 text-center">
                                No Record Found
                            </div>
                        }
                        <br />
                        <h5 className='fw-600 mt-3'>Past Allocated Devices Tickets</h5>
                        {
                            PastTickets.length != 0 ?
                                PastTickets.map((item, i) => {
                                    return <div className="col-md-12" key={i}>
                                        <div className="row" style={{ fontSize: "13px" }}>
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">Serial Number : </div>
                                                <div className="col fw-600">{item.serial_number}</div>
                                            </div>
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">{invoie_number_lable_user_wise} : </div>
                                                <div className="col fw-600">{item.parent_invoice_number || '-'}</div>
                                            </div >
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">Ticket Number : </div>
                                                <div className="col fw-600">{item.ticket_num || '-'}</div>
                                            </div>
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col " style={{ whiteSpace: "pre-line" }}>
                                                    {`${invoie_status_lable_user_wise} : `}
                                                </div>
                                                <div className="col fw-600">{item.parent_invoice_status == 1 ?
                                                    (
                                                        <FontAwesomeIcon icon={faStamp} title="Paid" className='' style={{ height: '14px', color: 'var(--paid_color)' }}
                                                        />) : (
                                                        <FontAwesomeIcon icon={faStamp} title="Not paid" className='' style={{ height: '14px', color: 'var(--unpaid_color)' }}
                                                        />)}</div>
                                            </div >
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">Created at : </div>
                                                <div className="col fw-600">{item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'}</div>
                                            </div>

                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">{invoice_amount_lable_user_wise} : </div>
                                                <div className="col fw-600">{item.parent_invoice_amount ? `$${item.parent_invoice_amount}` : <>-</>}</div>
                                            </div >
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">Ticket Status : </div>
                                                <div className="col fw-600">{item.status || '-'}</div>
                                            </div>
                                            <div className="col-lg-6 row py-1 pe-0">
                                                <div className="col ">Billable : </div>
                                                <div className="col fw-600">
                                                    <FontAwesomeIcon
                                                        className={`${item.chargeability == 1 ? 'text-blue-billable' : 'text-gray-billable'}`}
                                                        icon={faDollarSign}
                                                        style={{ height: '13px' }}
                                                        title={item.chargeability == 1 ? 'Billable' : 'Non-billable'}
                                                    />
                                                </div>
                                            </div>
                                            <hr />
                                        </div >
                                    </div >
                                })
                                :
                                <div className="col-12 text-center">
                                    No Record Found
                                </div>
                        }
                    </div >
                </div >

            )}
        </>
    )
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"lg"} title={"User Details"}
                closePopup={props.ClosePopup} modalBody={modalbody} visibleSaveBtn={false} />
        </>

    )
}
